<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <Button
        size="small"
        type="dashed"
        class="extra-btn"
        @click="goToMore"
        v-if="hasPageAccess('SHOP_AGENT_ANALYSIS_REPORT')"
      >
        {{ $t('common.more') }}
        <Icon type="ios-arrow-forward" />
      </Button>
      <slot name="extra"></slot>
    </a>
    <div class="top-line" v-if="scoringRule == 2">
      <Select v-model="scoringRuleModel" :transfer="false" style="width: 80px; height: 32px" @on-change="sortChange">
        <Option :value="0" key="top">{{ $t('home.score_rate') }}</Option>
        <Option :value="1" key="last">{{ $t('home.actual_score') }}</Option>
      </Select>
    </div>
    <div class="content">
      <div id="score-rate-secret-items"></div>
    </div>
  </Card>
</template>
<script>
import * as echarts from 'echarts';
import api from '../../../api/home/index';
import moment from 'moment';
import { privileageAccess } from '../../../mixins/privileage';
export default {
  components: {},
  props: {},
  mixins: [privileageAccess],
  data() {
    return {
      myChart: null,
      sortWay: 0,
      scoringRule: 0,
      scoringRuleModel: 0,
    };
  },
  mounted() {
    this.initEcharts();
  },
  methods: {
    // 排序
    sortChange() {
      let startTime = moment().month(moment().month()).startOf('month').format('YYYY-MM-DD HH:mm:ss');
      let endTime = moment().month(moment().month()).endOf('month').format('YYYY-MM-DD HH:mm:ss');
      let params = {
        startTime,
        endTime,
        orgOrDepIds: '',
        templateModelId: '',
        taskName: '',
        pageSize: 10,
        pageNumber: 1,
        averageSort: 0,
        scoringRule: this.scoringRuleModel,
      };
      this.getParentClassReport(params);
    },
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    async initEcharts() {
      let startTime = moment().month(moment().month()).startOf('month').format('YYYY-MM-DD HH:mm:ss');
      let endTime = moment().month(moment().month()).endOf('month').format('YYYY-MM-DD HH:mm:ss');
      let params = {
        startTime,
        endTime,
        orgOrDepIds: '',
        templateModelId: '',
        taskName: '',
        pageSize: 10,
        pageNumber: 1,
        averageSort: 0,
      };
      const userInfo = this.$system.$state.userInfo;
      let groupId = userInfo && userInfo.groupId ? userInfo.groupId : 0;
      let rule = await api.getReviewConfig({ enterpriseId: groupId });
      this.scoringRule = rule.scoringRule;
      if (this.scoringRule == 2) {
        params.scoringRule = this.scoringRuleModel;
      } else {
        this.scoringRuleModel = this.scoringRule;
        params.scoringRule = this.scoringRule;
      }
      this.getParentClassReport(params);
    },
    async getParentClassReport(params) {
      let res = await api.getParentClassReport(params);
      let dataName = res.records.map(i => i.parentClassName);
      let dataArr = res.records.map(i => i[params.scoringRule == 0 ? 'average' : 'actualScore'] || 0);
      let chartDom = document.getElementById('score-rate-secret-items');
      this.myChart = echarts.init(chartDom, null, { renderer: 'svg' });
      this.setOption(dataName, dataArr);
    },
    setOption(dataName, dataArr) {
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        grid: {
          left: '0',
          right: '0',
          bottom: '60',
          top: '20',
          containLabel: true,
        },
        xAxis: {
          interval: 0,
          data: dataName,
          axisTick: {
            //x轴刻度线
            show: false,
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置。
            formatter: function (params) {
              let val = '';
              if (params.length > 5) {
                val = params.substr(0, 5) + '...';
                return val;
              } else {
                return params;
              }
            },
          },
          axisLine: {
            lineStyle: {
              color: '#7F7F7F',
            },
          },
        },
        dataZoom: [
          {
            type: 'slider',
            showDetail: false,
            startValue: 0,
            endValue: 4,
            height: 8,
            bottom: 30,
            backgroundColor: 'rgba(229, 229, 229, 0.5)',
            dataBackground: {
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                opacity: 0,
              },
            },
            selectedDataBackground: {
              lineStyle: {
                opacity: 0,
              },
              areaStyle: {
                color: 'rgba(229, 229, 229, 1)',
              },
            },
            fillerColor: 'rgba(229, 229, 229, 1)',
            borderColor: 'rgba(0, 0, 0, 0)',
            showDataShadow: false,
            brushSelect: false,
            handleStyle: {
              opacity: 0,
            },
          },
        ],
        yAxis: {
          axisLine: {
            //y轴坐标轴
            show: false,
            lineStyle: {
              color: '#7F7F7F',
            },
          },
          max: 100,
          axisTick: {
            //y轴刻度线
            show: false,
          },
          splitLine: {
            lineStyle: {
              type: 'dashed',
            },
          },
        },
        series: {
          label: {
            show: true,
            position: 'top',
            color: '#FF9900',
          },
          barWidth: 10, //柱子宽度
          itemStyle: {
            color: '#FF9900',
          },
          data: dataArr,
          type: 'bar',
        },
      };
      // 绘制图表
      this.myChart.setOption(option);
    },
    goToMore() {
      let startTime = moment().month(moment().month()).startOf('month').format('YYYY-MM-DD');
      let endTime = moment().month(moment().month()).endOf('month').format('YYYY-MM-DD');

      this.$system.goRouter({
        router: {
          //路由跳转信息,必填
          // eslint-disable-next-line no-undef
          system: ccconstants.SYSTEM_NOS.Web_Store_Inspection, //系统编号，用于辨识该功能模块现在做在哪个系统里面
          url: `/shop-explorer/analysis-report/category-analysis?startTime=${startTime}&endTime=${endTime}&scoringRule=${
            this.scoringRule == 2 ? this.scoringRuleModel : this.scoringRule
          }`, //跳转路径，需要填写在相应系统里面的路由地址
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: #f0f0f0;
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}
.top-line {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative !important;
  .title {
    display: inline-block;
    margin-right: 5px;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
  }
}

.content {
  height: 100%;
  #score-rate-secret-items {
    width: 100%;
    height: 100%;
  }
}
</style>
